module.exports = __webpack_public_path__ + "img/scrubbing.8236a23.svg";